import axios from 'axios';
import Loader from '../modules/loader/components/Loader';
import Instruction from '../common/instruction/components/InstructionView';
import forIn from 'lodash/forIn';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import {mapGetters, mapActions, mapState} from 'vuex';
import UuidGenerator from '@/common/uuid/UuidGenerator';
import lang from '../lang/translator';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import {DATAPICKER} from '../modules/protocols/constants.js';
import Constants from '../modules/undesirableBehavior/Constants';
import VueTimepicker from 'vue2-timepicker';
import toInteger from 'lodash/toInteger';
import orderBy from 'lodash/orderBy';



export const maintainStage = {
  props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage', 'teachingMethod'],
  data() {
    return {
      apiUrlDetect: '/protocols/',
      apiCheckedUrl: '/protocols/assigned/',
      disabled: false,
      disabledSave: true,
      isLoaded: false,
      protocols: null,
      protocolsData: null,
      phaseSettings: [],
      activeStep: [],
      execution: '',
      stimulus: [],
      stimulList: [],
      attempts: {},
      currentSesssionDate: null,
      uiid: null,
      stimulusListEmpty: false,
      addStimulusItem: null,
      todayStimulList: null,
      allStimulList: null,
      visible: true,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WW',
        navMonths: 'MMM',
        input: ['DD MMM YYYY'],
        dayPopover: 'L',
        data: ['DD MMM YYYY'],
      },
      intervalTypes: [
        {typeId: '1', name: lang.get('protocol.through_each_lesson')},
        {typeId: '2', name: lang.get('protocol.after_one_lesson')},
        {typeId: '3', name: lang.get('protocol.after_two_classes')},
        {typeId: '4', name: lang.get('protocol.after_three_classes')},
        {typeId: '5', name: lang.get('protocol.once_a_week')},
        {typeId: '6', name: lang.get('protocol.once_every_two_weeks')},
        {typeId: '7', name: lang.get('protocol.once_a_month')},
      ],
      duration: null,
      showDatapicker: false,
      isModalVisible: false,
      showChangeDateSession: false,
      hourRange: [0, 23],
      minuteRange: [0, 60],
      maxDateStart: this.getMaxDateStart(new Date()),
      stageInfo: this.stage,
      protocolData: null,
      teachingMethodId: this.teachingMethod
    };
  },
  components: {
    Instruction,
    Loader,
    VueTimepicker
  },
  computed: {
    ...mapGetters('mobile', [
      'isMobile',
    ]),
    ...mapGetters('auth', [
      'isClient',
      'isBCBA',
      'isCurator',
      'isPreviousDateSession',
      'previousDate',
      'previousTime',
      'previousDuration'
    ]),

    ...mapState('protocol', [
      'protocolVuexData',
    ]),

    minDate() {
      return this.protocolData && this.protocolData.endDate ? moment(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
    },

    previousDateTimestamp() {
      return moment(this.previousDate).unix() - 3600
    },
    rangeDateEndTimestamp() {
      return moment(this.previousDate).unix() + 3600
    },

    showDatePrevious() {
      if (this.protocolData && this.protocolData.endDate && this.isPreviousDateSession  && this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm){

        let protocolDate = moment(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').unix();
        let sessionDate = new Date(this.previousDate.getFullYear(),
            this.previousDate.getMonth(),
            this.previousDate.getDate(),
            this.previousTime.HH,
            this.previousTime.mm);
        let previous = moment(sessionDate).unix()
        return previous <= protocolDate;

      }

      return false;
    },
  },
  async mounted() {
    this.todayStimulList = null;
    this.allStimulList = null;
    this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);
    await this.initProtocols();
    this.uiid = UuidGenerator.v4();
    let entity = {
      id: this.uiid,
      type: 'assigned-session',
    };

    if(!this.stage){
      let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);
      this.stageInfo = response.data.data;
    }

    if(!this.teachingMethod){
      this.teachingMethodId = await this.detectProtocol();
    }

    this.showDatapicker = DATAPICKER;

    this.setEntity(entity);
  },

  methods: {
    ...mapActions('appeals', [
      'setEntity',
    ]),

    ...mapActions('protocol', [
      'setProtocol',
      'setProtocolVersion',
    ]),

    detectProtocol: async function() {
      let response = await axios.get(this.apiCheckedUrl + this.protocolId + '/teaching-method' );
      return response.data.data.id;
    },

    changeNumber(event){
      if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
        event.preventDefault();
      }
    },

    cancelSession(){
      this.isModalVisible = false;
    },

    getMaxDateStart: function(date) {
      let clientTimeZoneOffset = this.client.timezone ? moment().tz(this.client.timezone)._offset : 0;
      let dateTime = moment(date, 'YYYY-MM-DD HH:mm').toDate();
      let dateWithTimezone = moment(dateTime.getTime() +
          (Math.abs(clientTimeZoneOffset) *
              Constants.SECONDS_PER_MINUTE * 1000)).toDate();

      return dateWithTimezone;
    },

    async checkSessionVersion() {
      let sessionVersion = axios.get(this.apiCheckedUrl + this.protocolId + '/is-version-equal/' + this.activeStep.majorVersion);
      return sessionVersion;
    },

    async saveSession(close = false){

      let stimulus = [];
      this.isLoaded = false;
      forEach(this.todayStimulList, item => {

        if (item.attemptAnswers.length || item.moveToPrevPhase){
          stimulus.push({
            globalUuid: item.globalUuid,
            answerId: item.attemptAnswers[0],
            description: item.description,
            moveBack: item.moveToPrevPhase,
            intervalType: item.intervalType,
          });
        }
      });

      let sessionDate = null;
      let timeSessionDate = null;
      let timeSessionEndDate = null;

      if (this.isPreviousDateSession){
        let clientTimeZoneOffset = this.client.timezone ? moment().tz(this.client.timezone)._offset : 0;
        sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
            this.previousDate.getMonth(),
            this.previousDate.getDate(),
            this.previousTime.HH,
            this.previousTime.mm));
        timeSessionDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
        timeSessionEndDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) + this.previousDuration * Constants.SECONDS_PER_MINUTE;
      }

      let isSaved;
      isSaved = axios.post(this.apiUrl + this.protocolId + '/sessions',
          {
            'assignedSessions': [
              {
                'uuid': this.uiid,
                //'dayUuid': UuidGenerator.v4(),
                'startedAt': this.isPreviousDateSession ? timeSessionDate : (this.currentSesssionDate ? this.currentSesssionDate : Math.round((new Date()).getTime() / 1000)) , //
                'finishedAt': this.isPreviousDateSession ? timeSessionEndDate : Math.round((new Date()).getTime() / 1000), //
                'stimuli': stimulus,
                'phaseId': this.activeStep.id,
                'type': this.activeStep.taskType
              }
            ],
            'uuid': this.stageInfo.uuid,
            'close': close,
            'index': this.stageInfo.position,
            'majorVersion': this.activeStep.majorVersion
          }).then(response => {
            if (close){
              this.$router.push({name: 'client-edit', params: { clientId: this.protocols.assigneeId }});
            } else{
              this.setProtocol(null);
              if(this.teachingMethodId == 1){
                this.$router.push({name: 'choose-stage'});
              } else{
                this.$router.push({name: 'choose-usd'});
              }

            }
            this.isLoaded = true;
          }).catch(error => {
            console.info(error)
          });



    },

    async saveStage(close = false) {

      let checkVersion = await this.checkSessionVersion();
      if (checkVersion.data.data.result){
        this.saveSession(close);
      } else{
        this.isModalVisible = true;
      }

    },


    initProtocols: async function () {
      this.isLoaded = false;
      this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);
      this.uuid = UuidGenerator.v4();
      let entity = {
        id: this.uuid,
        type: 'assigned-session',
      };

      this.setEntity(entity);
      await this.getProtocols();
      this.isLoaded = true;
    },

    getInterval(id) {
      let interval = null;
      forEach(this.intervalTypes, (item) => {
        if (item.typeId == id) {
          interval = item
        }
      });
      if (interval) {
        return interval.name;
      }
    },


    attemptChange: function (answer, stimul) {
      stimul.toRotation =  this.rotationBack(stimul, answer)
      stimul.disabled = true;
      stimul.attemptAnswers.push(answer)
      this.disabledSave = false;

      setTimeout(function() {
        stimul.answer = null;
      }, 800);
    },

    goToPrevPhase: function (id) {
      let stimuls = cloneDeep(this.todayStimulList);

      forIn(stimuls, function (item) {
        if (item.globalUuid == id) {
          item.moveToPrevPhase = true;
        }
      });

      setTimeout(() => {
        this.todayStimulList = stimuls;
        this.disabledSave = false;
      }, 200);
    },


    backToPreviousAttempt: function (id) {

      let stimuls = cloneDeep(this.todayStimulList);

      forIn(stimuls, (item) => {
        if (item.globalUuid == id) {
          item.attemptAnswers.pop();
          item.disabled = false;
          item.answer = null;
          item.toRotation =  this.rotationBack(item)
        }
      });

      setTimeout(() => {
        this.todayStimulList = stimuls;
      }, 200);

    },

    rotationBack: function(stimul, answer = "") {
      let negative = filter(stimul.type.answers, function(item) { return !item.himself; });
      let negativeAnswer = negative[0].id;

      if (stimul.answers){
        if ((stimul.answers[0] == negativeAnswer && stimul.answers[1] == negativeAnswer) || (stimul.answers[0] == negativeAnswer && answer == negativeAnswer)){
          return true;
        } else{
          return false;
        }
      }

    },

    getProtocols: async function () {
      try {

        let params = {};

        if(this.isPreviousDateSession && this.previousDate) {
          let newDate = moment(this.previousDate).format('YYYY-MM-DD');
          let newDateUnix = moment.utc(newDate, 'YYYY-MM-DD').unix();

          let timeSessionDate = moment.utc(this.previousDate).unix;
          params = {
            date: newDateUnix
          };

        }

        let response = await axios.get(this.apiUrl +
            this.protocolId + '/stage/' + this.stageId + '/phase/3/', {params: params});

        if (response) {
          this.protocolData = this.protocolVuexData;
          this.protocols = this.protocolData.protocol;
          this.activeStep = response.data.data;
          this.stimulList = this.activeStep.tasks;
          this.execution = this.protocols.execution;

          let stimuliList = this.activeStep.stimuli;
          let taskType = this.activeStep.taskType;

          forIn(stimuliList, (item) => {

            item.title = item.description;
            item.type = taskType;
            item.attemptAnswers = [];
            item.disabled = false;
            item.moveToPrevPhase = false;
            item.toRotation = this.rotationBack(item);

          });

          this.todayStimulList = filter(stimuliList, 'showToday');
          this.todayStimulList = orderBy(this.todayStimulList, 'position');
          this.allStimulList = filter(stimuliList, ['showToday', false]);
        }

      } catch (error) {
        console.dir(error);
      } finally {
        this.isLoaded = true;
      }
    },

  },
  watch: {
    previousDate(newValue){
      this.getProtocols();
    },
    isPreviousDateSession(newValue){
      this.getProtocols();
    }

  }

};



// WEBPACK FOOTER //
// ./src/mixins/maintainStage.js